export const MIN_THUMB_WIDTH_PX = 48;
export const EDGE_VISIBILITY_PADDING_PX = 8;
export const PREVIEW_CARD_SELECTOR_ATTR = "data-preview-card";
export const SCROLL_THUMB_TEST_ID = "preview-selector-thumb";
